import { InheritanceStatus, LocationVarKey, VarDef, VarKey, isNLPBrain } from "@swivl-mono/types";
import { Button, ButtonVariant, Dropdown, SelectableOption, Spinner } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { BrainsModel } from "../../../Models/Brains/Brains.Model";
import ModalModel from "../../../Models/Modal/Modal.Model";
import NLPModel from "../../../Models/NLP/NLP.Model";
import LocationVarsModel from "../../../Models/Variables/LocationVars.Model";
import "./BrainsSettingView.scss";
import { AddBrainsModal } from "./Modal/AddBrainsModal";

function BrainItem(ItemProps) {
  const { brain, cachesMap } = ItemProps;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const deleteBrain = async () => {
    if (window.confirm("Are you sure you want to delete this brain?")) {
      setLoading(true);
      await BrainsModel.deleteBrain(brain);
      setLoading(false);
    }
  };

  if (isNLPBrain(brain)) {
    return (
      <div className="BrainItem">
        <div className="type mr-1">{brain.type}</div>
        <div className="inheritance">{brain.inheritance === InheritanceStatus.IS_PARENT && "(PARENT)"}</div>
        <div className="name">{brain.name}</div>
        <div className="description mr-2">{NLPModel.nameForCachedModel(brain.model.appId, brain.model.version)}</div>
        {brain.inheritance !== InheritanceStatus.IS_PARENT && (
          <Button
            loading={loading}
            onClick={deleteBrain}
            variant={ButtonVariant.GHOST}
          >
            DELETE
          </Button>
        )}
        <Button
          loading={loading}
          onClick={() => navigate(`/brain/${brain.slug}`)}
        >
          {brain.inheritance === InheritanceStatus.IS_PARENT ? "VIEW" : "EDIT"}
        </Button>
      </div>
    );
  }

  return (
    <div className="BrainItem">
      <div className="type llm">{brain.type}</div>
      <div className="inheritance">{brain.inheritance === InheritanceStatus.IS_PARENT && "(PARENT)"}</div>
      <div className="name">{brain.name}</div>

      {brain.inheritance !== InheritanceStatus.IS_PARENT && (
        <Button onClick={deleteBrain} loading={loading}>
          Delete
        </Button>
      )}
      <Button onClick={() => navigate(`/brain/${brain.slug}`)} loading={loading}>
        {brain.inheritance === InheritanceStatus.IS_PARENT ? "VIEW" : "EDIT"}
      </Button>
    </div>
  );
}

export default function BrainsSettingView() {
  const { brains } = BrainsModel.useState((state) => state);
  const { orgVariables } = LocationVarsModel.useState((s) => s);

  const { cachesMap } = NLPModel.useState((state) => state);
  const navigate = useNavigate();
  useEffect(() => {
    BrainsModel.load(false);
    NLPModel.loadCaches();
  }, []);

  if (!brains) {
    return (
      <div className="BrainsSettingView">
        <Spinner />{" "}
      </div>
    );
  }

  const addBrainClicked = () => {
    ModalModel.showModalWithContent(null, <AddBrainsModal navigate={navigate} />, 800);
  };

  const globalBrainSlug =
    orgVariables && orgVariables[LocationVarKey.BrainSlug]
      ? orgVariables[LocationVarKey.BrainSlug]?.value
      : VarDef[VarKey.LocationBrainSlug]?.defaultValue || "";

  const brainItems: SelectableOption[] = [];
  if (brains) {
    brains.forEach((brainToAdd) => {
      brainItems.push({
        label: brainToAdd.inheritance === InheritanceStatus.IS_PARENT ? brainToAdd.name + " [PARENT]" : brainToAdd.name,
        value: brainToAdd.slug,
        data: { isBrain: true },
      });
    });
  }

  return (
    <div className="BrainsSettingView">
      <label>Global Brain</label>

      <Dropdown
        options={brainItems}
        optionSelected={(option) => {
          BrainsModel.setGlobalBrainSlug(option.value);
        }}
        value={globalBrainSlug}
      />

      <hr />

      <label>Brains</label>

      {brains.map((brain) => {
        return <BrainItem key={brain.slug} brain={brain} cachesMap={cachesMap} />;
      })}
      <Button variant={ButtonVariant.DASHED} onClick={addBrainClicked}>
        + Brain
      </Button>
    </div>
  );
}
